import type { ComponentProps } from "react";

export default function EyeDropperIcon(svgProps: ComponentProps<"svg">) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      {...svgProps}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_35688_1609)">
        <path
          d="M23 5.07143C21.5714 3.64286 19.2857 3.64286 17.9286 5.07143L15.2857 7.71429C14.5 7.35714 13.5 7.42857 12.8571 8.14286C12 9 12 10.3571 12.8571 11.2143L6.71429 17.3571C6.28571 17.7857 6.07143 18.3571 6.07143 19L4.64286 20.4286C3.78571 21.2857 3.78571 22.6429 4.64286 23.5C5.14286 23.7857 5.64286 24 6.21429 24C6.78571 24 7.28571 23.7857 7.71429 23.3571L9.14286 21.9286C9.71429 22 10.3571 21.7143 10.7857 21.2857L16.9286 15.1429C17.3571 15.5714 17.9286 15.7857 18.4286 15.7857C19 15.7857 19.5 15.5714 19.9286 15.1429C20.5714 14.5 20.7143 13.5 20.3571 12.7143L23 10.0714C24.4286 8.71429 24.4286 6.42857 23 5.07143ZM15.9286 14.2143L13.2857 16.8571H9.14286L13.8571 12.1429L15.9286 14.2143Z"
          fill="#6B7280"
        />
      </g>
      <defs>
        <clipPath id="clip0_35688_1609">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
